import { Box, Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface StakeFormDetailItem {
  label: string;
  value?: string;
  valueNode?: ReactNode;
}

export const StakeFormDetails = ({ items }: { items: StakeFormDetailItem[] }) => {
  if (items.length === 0) return null;

  return (
    <Box
      mt={3}
      pt={3}
      borderTop="1px solid"
      borderColor="whiteAlpha.200"
      width="100%"
    >
      {items.map(({ label, value, valueNode }) => (
        <Flex
          key={label}
          justify="space-between"
          align="center"
          gap={3}
          py={1}
          fontSize="xs"
        >
          <Text color="whiteAlpha.700" flexShrink={0}>
            {label}
          </Text>
          {valueNode ? (
            <Flex flex={1} justify="flex-end" minW={0}>
              {valueNode}
            </Flex>
          ) : (
            <Text color="whiteAlpha.900" textAlign="right" fontWeight="medium">
              {value}
            </Text>
          )}
        </Flex>
      ))}
    </Box>
  );
};
